var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_037-3d",
    "data-name": "037-3d",
    transform: "translate(-62 -22)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(77 62.5)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M90.317,22H66.683A4.688,4.688,0,0,0,62,26.683V65.317A4.688,4.688,0,0,0,66.683,70H90.317A4.688,4.688,0,0,0,95,65.317V26.683A4.688,4.688,0,0,0,90.317,22ZM65,26.683A1.685,1.685,0,0,1,66.683,25H90.317A1.685,1.685,0,0,1,92,26.683V58H65ZM90.317,67H66.683A1.685,1.685,0,0,1,65,65.317V61H92v4.317A1.685,1.685,0,0,1,90.317,67Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M109.091,66.621l-10.5-4.5a1.5,1.5,0,0,0-1.182,0l-10.5,4.5A1.5,1.5,0,0,0,86,68V80a1.5,1.5,0,0,0,.909,1.379l10.5,4.5v0a1.484,1.484,0,0,0,1.181,0l10.5-4.5A1.5,1.5,0,0,0,110,80V68a1.5,1.5,0,0,0-.909-1.379ZM98,65.132,104.692,68,98,70.868,91.308,68Zm-9,5.143,7.5,3.214v8.736L89,79.011Zm10.5,11.95V73.489l7.5-3.214v8.736Z",
    transform: "translate(-19.5 -32.5)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature8);
export default __webpack_public_path__ + "static/media/feature_8.75c80e1725ebee1b7c893ed870514fc1.svg";
export { ForwardRef as ReactComponent };